import { FilterOperator, getReportsByCriteria } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { ReportDetailsOverview } from '@/components/modules/Reports/ReportDetails/ReportDetailsOverview/ReportDetailsOverview';
import { ReportPayoutsTable } from '@/components/modules/Reports/ReportDetails/ReportPayoutsTable/ReportPayoutsTable';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { useOperationsContext } from '@/contexts/OperationsContext/OperationsContext';
import { useCache } from '@/hooks/requests/useCache';
import { queryStringBuilder } from '@/utils/queryStringBuilder';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const ReportDetails = () => {
  const { reportId } = useParams();
  const {
    state: { selectedReport },
  } = useOperationsContext();

  const report = selectedReport
    ? selectedReport
    : useCache(getReportsByCriteria, {
        query: queryStringBuilder({
          page: 1,
          pageSize: 10,
          orderBy: 'report_date',
          direction: 'desc',
          filters: reportId ? [{ operator: FilterOperator.EQUAL, field: 'id', value: reportId }] : [],
          search: '',
        }),
      })?.data?.data.find((report) => report.id === reportId);

  if (!reportId || !report || report?.id !== reportId) return <PendingDataWarning />;

  return (
    <>
      <ReportDetailsOverview report={report} />
      <ReportPayoutsTable report={report} />
    </>
  );
};

export const ReportDetailsModule = withPermissionsModule(ReportDetails);
